import React, { useContext, useState } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import FormAdvancedOptions from "./FormAdvancedOptions";
import FormWrap from "../common/FormWrap";
const StepSubscribe = ({ onSubmit, onChange }) => {
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { checkpointIntervalSeconds } = formData;
  const handleSubmit = () => {
    if (checkpointIntervalSeconds.value < 5) {
      setFormError({
        full_message: "Please provide valid checkpoint interval",
        nice_message: "Minimum allowable checkpoint interval is 5 seconds."
      });
      return;
    }
    setFormError(null);
    onSubmit();
  };
  return /* @__PURE__ */ React.createElement(FormWrap, { onSubmit: handleSubmit, buttonContent: "Proceed", title: "", error: formError, description: "" }, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "checkpointIntervalSeconds",
      name: "checkpointIntervalSeconds",
      type: "number",
      value: checkpointIntervalSeconds.value || checkpointIntervalSeconds.defaultValue || "",
      min: "1",
      max: "60",
      step: "1",
      onChange,
      required: true,
      help: "How often (in seconds) record checkpoints for CrowdStrike data streams will be checked.",
      label: "Checkpoint Interval"
    }
  ), /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange }));
};
export default StepSubscribe;
